import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import AutoComplete from '../../components/autocompleteChips/AutoComplete'
import ChipsPanel from '../../components/autocompleteChips/ChipsPanel'
import i18n from 'simple-react-i18n'
import { checkBetaUser } from '../../utils/UserUtils'
import DtoUserRole from '../../home/dto/DtoUserRole'
import DtoUser from '../../home/dto/DtoUser'
import { MAP_RESEARCH } from '../../sites/constants/SitesConstants'

class ResearchBarPanel extends Component {
	constructor(props) {
		super(props)
	}

	getActionButtons = () => {
		if (this.props.actions) {
			return (
				<div className='col s1 right-align no-padding'>
					{ this.props.actions }
				</div>
			)
		}
		return (
			<div className='col s1 right-align no-padding'>
				<a type='submit' name='action' onClick={ () => this.props.researchClick() }>
					<i className='material-icons black-text small-research-icon'>search</i>
				</a>
			</div>
		)
	}

	getRestrictPanel = () => {
		const color = (() => {
			if (this.props.page === MAP_RESEARCH) {
				return '#696969'
			}
			return 'white'
		})()
		return (
			<div className='col s12 no-padding'>
				<div className='row no-margin'>
					<div className='col s12 left-align no-padding' style={ { backgroundColor: 'transparent !important' } }>
						<div className='row no-margin text-left' style={ {
							color: color,
							borderBottom: '0',
							boxShadow: 'none',
							fontSize: '14px'
						} }>
							{ i18n.criteriaLimitBeta }
						</div>
					</div>
				</div>
			</div>
		)
	}
	setRestrictPanel = (isBeta) => {
		if (!this.props.isLogged) {
			if (!this.props.selectedFilters.length) {
				return null
			}
			return this.getRestrictPanel()
		} else if (isBeta) {
			if (!this.props.selectedFilters.length) {
				return null
			}
			return this.getRestrictPanel()
		}
		return null
	}
	getAutoComplete = (isBeta) => {
		if (!this.props.isLogged) {
			if (!this.props.selectedFilters.length) {
				return (
					<AutoComplete isResearchMap={ this.props.isResearchMap }/>
				)
			}
			return null
		} else if (isBeta) {
			if (!this.props.selectedFilters.length) {
				return (
					<AutoComplete isResearchMap={ this.props.isResearchMap }/>
				)
			}
			return null
		}
		return (
			<AutoComplete isResearchMap={ this.props.isResearchMap }/>
		)
	}

	render() {
		const isBeta = checkBetaUser(this.props.userRoles).length
		return (
			<div className='row no-margin'>
				<div className='col s12 no-padding search-panel '>
					<div className='row no-margin valign-wrapper'>
						<div className='col s12 left-align no-padding'>
							<ChipsPanel/>
							<div className='row no-margin no-padding'>
								<div className='col s11 no-padding no-margin'>
									{ this.getAutoComplete(isBeta) }
								</div>
								{ this.getActionButtons() }
							</div>
						</div>
					</div>
				</div>
				{ this.setRestrictPanel(isBeta) }
			</div>
		)
	}
}

ResearchBarPanel.propTypes = {
	selectedFilters: PropTypes.arrayOf(PropTypes.shape({
		label: PropTypes.string,
		value: PropTypes.object
	})),
	isLogged: PropTypes.bool,
	isResearchMap: PropTypes.bool,
	researchClick: PropTypes.func,
	actions: PropTypes.object,
	user: PropTypes.instanceOf(DtoUser),
	userRoles: PropTypes.arrayOf(PropTypes.instanceOf(DtoUserRole)),
	page: PropTypes.string
}
ResearchBarPanel.defaultProps = {
	isResearchMap: false,
	isLogged: false,
	page: MAP_RESEARCH
}

const mapStateToProps = store => {
	return {
		selectedFilters: store.AdministrationReducer.selectedFilters,
		selectedThemes: store.AdministrationReducer.selectedThemes,
		themes: store.AdministrationReducer.themes,
		filterTypes: store.ReferentialReducer.filterTypes,
		user: store.HomeReducer.user,
		userRoles: store.HomeReducer.userRoles
	}
}

export default connect(mapStateToProps)(ResearchBarPanel)



// WEBPACK FOOTER //
// ./src/research/components/ResearchBarPanel.js